/* eslint-disable no-param-reassign */
// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dashboardSearch: '',
  dashboardActiveFilter: {},
  archivedModelSearch: '',
  modelAssociationSearch: '',
  modelAssociationSearchTemplate: '',
  templateListSearch: '',
  entityRelationshipListSearch: '',
  appManagementListSearch: '',
  workFlowListSearch: '',
  rulesSearch: '',
  userListSearch: '',
  groupListSearch: '',
  documentInventorySearch: '',
  documentTemplateSearch: '',
  userRoleListSearch: '',
  issueTypeListSearch: '',
  summaryTabsListSearch: '',
  isWorkflowCompiled: true,
  modelRequestSearch: '',
  accessRequestSearch: '',
  useCaseSearch: '',
  querySearch: '',
  triggerThemeChange: false,
  triggerHeaderIconChange: false,
  triggerProductIconChange: false,
  emailTemplateListSearch: '',
  // if you are changing keys, also update its usage location
  tableSearch: {
    modelInventorySearch: '',
    modelInventoryMyModelsSearch: '',
    modelAssociationSearch: '',
    modelAssociationMyArtifactsSearch: '',
    modelRequestSearch: '',
    modelRequestMyModelRequestSearch: '',
    useCaseSearch: '',
    useCaseMyUseCaseSearch: '',
    querySearch: '',
    queryMyQuerySearch: '',
    modelInventoryTemporalSearch: '',
    modelInventoryMyModelsTemporalSearch: '',
    modelAssociationTemporalSearch: '',
    modelAssociationMyArtifactsTemporalSearch: '',
  },
  tableSelectedTemplate: {
    modelInventorySearchTemplate: '',
    modelAssociationSearchTemplate: '',
    modelRequestSearchTemplate: '',
    useCaseSearchTemplate: '',
    querySearchTemplate: '',
    modelInventoryTemporalSearchTemplate: '',
    modelAssociationTemporalSearchTemplate: '',
  },
  userSetting: {
    // it will store hidden column and column order,
    modelInventory: {},
    modelAssociation: {},
    modelRequest: {},
    useCase: {},
    query: {},
    accessRequest: {},
    temporalViewModelInventory: {},
    temporalViewModelAssociation: {},
    temporalViewModelRequest: {},
    temporalViewUseCase: {},
    temporalViewQuery: {},
  },
  sectionPermissions: {},
  workflowGroupsVar: {},
  issueTypetablePreferences: {},
};
export const commonSlice = createSlice({
  initialState,
  name: 'common',
  reducers: {
    setDashboardSearch: (state, action) => {
      return {
        ...state,
        dashboardSearch: action.payload,
      };
    },
    setDashboardActiveFilter: (state, action) => {
      return {
        ...state,
        dashboardActiveFilter: action.payload,
      };
    },
    /**
     * we can directly mutate state,
     * redux internally uses immerjs, which allows mutating state, and
     * it's completely fine, and we don't need an extra spreading operation
     */
    setTableSearch: (state, action) => {
      const { key, value } = action.payload;
      state.tableSearch[key] = value;
    },
    setTableSelectedTemplate: (state, action) => {
      const { key, value } = action.payload;
      state.tableSelectedTemplate[key] = value;
    },
    setIssueTypeTablePreferences: (state, action) => {
      const { key, value } = action.payload;
      state.issueTypetablePreferences = {
        ...state.issueTypetablePreferences,
        [key]: value,
      };
    },

    setUserSetting: (state, action) => {
      const { path, data } = action.payload;
      if (!path) return;

      const keys = path?.split('.') ?? [];

      if (!state.userSetting) {
        state.userSetting = {};
      }

      let target = state.userSetting || {};

      for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];

        // create nested object if it does not exist
        if (!target[key]) {
          target[key] = {};
        }

        target = target[key];
      }

      target[keys[keys.length - 1]] = data;
    },
    setFreshUserSetting: (state, action) => {
      state.userSetting = action.payload;
    },
    setModelArchivedSearch: (state, action) => {
      return {
        ...state,
        archivedModelSearch: action.payload,
      };
    },
    setModelAssociationSearch: (state, action) => {
      return {
        ...state,
        modelAssociationSearch: action.payload,
      };
    },
    setModelAssociationSearchTemplate: (state, action) => {
      return {
        ...state,
        modelAssociationSearchTemplate: action.payload,
      };
    },
    setTemplateListSearch: (state, action) => {
      return {
        ...state,
        templateListSearch: action.payload,
      };
    },
    setEntityRelationshipListSearch: (state, action) => {
      return {
        ...state,
        entityRelationshipListSearch: action.payload,
      };
    },
    setEmailTemplateListSearch: (state, action) => {
      return {
        ...state,
        emailTemplateListSearch: action.payload,
      };
    },
    setAppManagementSearch: (state, action) => {
      return {
        ...state,
        appManagementListSearch: action.payload,
      };
    },
    setIsWorkflowCompiled: (state, action) => {
      return {
        ...state,
        isWorkflowCompiled: action.payload,
      };
    },
    setIsDraftWorkflowSaved: (state, action) => {
      return {
        ...state,
        isDraftWorkflowSaved: action.payload,
      };
    },
    setWorkFlowListSearch: (state, action) => {
      return {
        ...state,
        workFlowListSearch: action.payload,
      };
    },
    setRulesSearch: (state, action) => {
      return {
        ...state,
        rulesSearch: action.payload,
      };
    },
    setUserListSearch: (state, action) => {
      return {
        ...state,
        userListSearch: action.payload,
      };
    },
    setGroupListSearch: (state, action) => {
      return {
        ...state,
        groupListSearch: action.payload,
      };
    },
    setDocumentInventorySearch: (state, action) => {
      return {
        ...state,
        documentInventorySearch: action.payload,
      };
    },
    setDocumentTemplateSearch: (state, action) => {
      return {
        ...state,
        documentTemplateSearch: action.payload,
      };
    },
    setModelInventoryHiddenColumns: (state, action) => {
      return {
        ...state,
        modelInventoryHiddenColumns: action.payload,
      };
    },
    setModelAssociationHiddenColumns: (state, action) => {
      return {
        ...state,
        modelAssocationHiddenColumns: action.payload,
      };
    },
    setModelInventoryColumnOrder: (state, action) => {
      return {
        ...state,
        modelInventoryColumnOrder: action.payload,
      };
    },
    setModelAssociationColumnOrder: (state, action) => {
      return {
        ...state,
        modelAssociationColumnOrder: action.payload,
      };
    },
    setUserRoleListSearch: (state, action) => {
      return {
        ...state,
        userRoleListSearch: action.payload,
      };
    },
    setIssueTypeListSearch: (state, action) => {
      return {
        ...state,
        issueTypeListSearch: action.payload,
      };
    },
    setSummaryTabsListSearch: (state, action) => {
      return {
        ...state,
        summaryTabsListSearch: action.payload,
      };
    },
    setModelRequestSearch: (state, action) => {
      return {
        ...state,
        modelRequestSearch: action.payload,
      };
    },
    setAccessRequestSearch: (state, action) => {
      return {
        ...state,
        accessRequestSearch: action.payload,
      };
    },
    setUseCaseSearch: (state, action) => {
      return {
        ...state,
        useCaseSearch: action.payload,
      };
    },
    setQuerySearch: (state, action) => {
      return {
        ...state,
        querySearch: action.payload,
      };
    },
    setTriggerThemeChange: (state, action) => {
      return {
        ...state,
        triggerThemeChange: action.payload,
      };
    },
    setTriggerProductIconChange: (state, action) => {
      return {
        ...state,
        triggerProductIconChange: action.payload,
      };
    },
    setTriggerHeaderIconChange: (state, action) => {
      return {
        ...state,
        triggerHeaderIconChange: action.payload,
      };
    },
    setSectionPermissions: (state, action) => {
      const { entity_id, entity_type, data } = action.payload;
      const key = `${entity_type}_${entity_id}`;
      state.sectionPermissions[key] = data;
    },
    setWorkflowGroupNodes: (state, action) => {
      const { entity_id, entity_type, data } = action.payload;
      const key = `${entity_type}_${entity_id}`;
      if (!state.workflowGroupsVar[key]) {
        state.workflowGroupsVar[key] = {
          entityWorkflowGroups: [],
          entityCurrentGroupId: '',
        };
      }
      state.workflowGroupsVar[key].entityWorkflowGroups = data;
    },
    setCurrentWorkflowGroupId: (state, action) => {
      const { entity_id, entity_type, data } = action.payload;
      const key = `${entity_type}_${entity_id}`;
      if (!state.workflowGroupsVar[key]) {
        state.workflowGroupsVar[key] = {
          entityWorkflowGroups: [],
          entityCurrentGroupId: '',
        };
      }
      state.workflowGroupsVar[key].entityCurrentGroupId = data;
    },
  },
});
export const {
  setTableSearch,
  setTableSelectedTemplate,
  setDashboardSearch,
  setDashboardActiveFilter,
  setModelArchivedSearch,
  setModelAssociationSearch,
  setModelAssociationSearchTemplate,
  setTemplateListSearch,
  setEntityRelationshipListSearch,
  setAppManagementSearch,
  setWorkFlowListSearch,
  setRulesSearch,
  setUserListSearch,
  setGroupListSearch,
  setDocumentInventorySearch,
  setDocumentTemplateSearch,
  setUserRoleListSearch,
  setIssueTypeListSearch,
  setSummaryTabsListSearch,
  setUserSetting,
  setFreshUserSetting,
  setIsWorkflowCompiled,
  setIsDraftWorkflowSaved,
  setModelRequestSearch,
  setAccessRequestSearch,
  setUseCaseSearch,
  setQuerySearch,
  setTriggerThemeChange,
  setTriggerProductIconChange,
  setTriggerHeaderIconChange,
  setEmailTemplateListSearch,
  setSectionPermissions,
  setWorkflowGroupNodes,
  setCurrentWorkflowGroupId,
  setIssueTypeTablePreferences,
} = commonSlice.actions;
export default commonSlice.reducer;
